/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, March 2020
 *
 *****************************************************************************/

import React, { Component } from "react";
import { Auth } from "aws-amplify";
import Logo from "./../assets/logo/ServiceActivator-DarkBackground.png";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import cloneDeep from "lodash/cloneDeep";
import { withStyles } from "@material-ui/core/styles";
import axios from "axios";
import { toast } from "react-toastify";
import { isPhoneValid, isCodeValid } from "./../shared/utility";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import constant from "../locale/en";
import * as color from "../shared/theme/color";

//Get default community domain
const REACT_APP_API_DEFAULT_URL = process.env.REACT_APP_API_DEFAULT_URL

class SignIn extends Component {
  // called before any function when rendered to this page
  constructor(props) {
    // passed props in super (parent class) so that props can be used in constructor
    super(props);

    // store updated user object for code retries
    this.user = null;
    this.state = {
      // store mobile number value
      phone: "+1 ",

      // store error string
      error: "",

      // store verification code value
      code: "",

      // decide which form should be visible signIn verification code
      isVerifyFormVisible: false,

      // decide when submit button should be disabled
      disableSignInBtn: false,
      disableVerifyBtn: false,
    };
    // store verification code retries count on failure
    this.codeRetriesCount = 0;

    // redirect url after login
    this.returnUrl = null;
  }

  // Called before rendering view first time
  componentWillMount() {
    /**
     * set variable in localStorage so that Loading page
     * can verify if it is rendered from signedIn page
     */
    localStorage.setItem("isFromSignIn", true);
    let params = new URLSearchParams(window.location.search);
    this.returnUrl = params.get("ref");
  }

  /**
   * handle the state of aws cognito
   * state = {
   - signIn,
   - signUp
   - confirmSignIn
   - confirmSignUp
   - forgotPassword
   - requireNewPassword
   - verifyContact
   - signedIn
  }*/
  changeState(type, event) {
    const { changeAuthState } = this.props;
    changeAuthState(type, event);
  }

  // set valid mobile number in state (phone variable)
  updatePhoneInput = (e) => {
    if (!isPhoneValid(e.target.value)) return;
    this.setState({ phone: e.target.value, error: null });
  };

  // set valid verification code in state (code variable)
  updateCodeInput = (e) => {
    if (!isCodeValid(e.target.value)) return;
    this.setState({ code: e.target.value, error: null });
  };

  // set error string in state (error variable)
  setError = (error) => {
    this.setState({ error });
  };

  // toggle submit signIn button disability in state
  toggleSignInBtnDisability = () => {
    this.setState({ disableSignInBtn: !this.state.disableSignInBtn });
  };

  // toggle verify button disability in state
  toggleVerifyBtnDisability = () => {
    this.setState({ disableVerifyBtn: !this.state.disableVerifyBtn });
  };

  /**
   * Initiate authenticating process
   * verify mobile number
   */
  initiateAuth = (event) => {
    // prevent default javascript operation on submitting form
    event.preventDefault();

    // fetch the mobile number from state
    const { phone } = this.state;

    // check if mobile number field is empty
    if (phone === "+1 ") {
      this.setError(constant.MANDATORY);
      return;
    }

    // validate mobile number length
    let number = phone.split(" ")[1];
    if (number && (number.length < 10 || number.length > 10)) {
      this.setError(constant.MOBILE_NUMBER_SHOULD_BE_OF_10_DIGITS);
      return;
    }

    // append +1 to mobile number
    number = "+1" + number;

    // disable sign in button
    this.toggleSignInBtnDisability();
    this.setState({ code: "" });

    // call aws cognito method to verify mobile number
    Auth.signIn(number)
      .then((user) => {
        // enable submit button
        this.toggleSignInBtnDisability();

        // hide signIn form and show verification code form
        this.setState({ isVerifyFormVisible: true });

        // store the user object (this will be used in verification code process)
        this.user = cloneDeep(user);
      })
      .catch((err) => {
        // enable submit button
        this.toggleSignInBtnDisability();

        // show user not found error
        this.setError(constant.USER_NOT_FOUND);
      });
  };

  // // call salesforce api to fetch salesforce home url
  // salesforceApiHandler = (token) => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_BASE_URL}/user/login`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((res) => {
  //       let salesforceUrl = res.headers["x-location"];
  //       // open the url in current tab
  //       window.open(salesforceUrl, "_self");
  //     })
  //     .catch((err) => {});
  // };

  // call aws cognito method to verify verification code
  verifyCodeHandler = (event) => {
    // prevent default javascript operation on submitting form
    event.preventDefault();

    // fetch the verification code from state
    const { code } = this.state;

    // check if verification code field is empty
    if (code === "") {
      this.setError(constant.MANDATORY);
      return;
    }
    // validate verification code length
    if (code.length > 6 || code.length < 6) {
      this.setError(constant.CODE_MUST_BE_OF_6_DIGITS);
      return;
    }
    this.setState({ disableVerifyBtn: true });

    // call aws cognito method to verify verification code
    Auth.sendCustomChallengeAnswer(this.user, code)
      .then((user) => {
        // enable submit button

        // store the user object (this will be used in verification code process for retries)
        this.user = cloneDeep(user);

        this.setState({ disableVerifyBtn: false });

        // user signed in successfully
        if (user.signInUserSession) {
          // change aws state to signedIn (redirect to loading pade)
          this.changeState("signedIn", user);

          if (this.returnUrl) {
            // redirect to referrer web app
            window.open(this.returnUrl, "_self");
          } else {
            // call salesforceApi with idToken
            // this.salesforceApiHandler(user.signInUserSession.idToken.jwtToken);

            // redirect to default community web app
            window.open(REACT_APP_API_DEFAULT_URL, "_self");
          }

          // set retries count to 0
          this.codeRetriesCount = 0;
        }
        // user signed in failed
        else {
          // increase the retries count on failure
          this.codeRetriesCount++;

          // retries count exceed maximum count redirect to signed In page
          if (this.codeRetriesCount >= 3) {
            // set retries count to 0
            this.codeRetriesCount = 0;

            // hide verification code form and show signIn form
            this.setState({
              isVerifyFormVisible: false,
              error: null,
              code: "",
            });

            // show toast notification
            toast.error(constant.MAXIMUM_RETRIES_EXCEEDED);
            return;
          }
          // show Invalid code error
          this.setError(constant.INVALID_CODE);
        }
      })
      .catch((err) => {
        // increase the retries count on failure
        this.codeRetriesCount++;

        this.setState({ disableVerifyBtn: false });

        // retries count exceed maximum count redirect to signed In page
        if (this.codeRetriesCount >= 3) {
          // set retries count to 0
          this.codeRetriesCount = 0;

          // hide verification code form and show signIn form
          this.setState({
            isVerifyFormVisible: false,
            error: null,
            code: "",
          });
          toast.error(constant.MAXIMUM_RETRIES_EXCEEDED);
          return;
        }
        // show Invalid code error
        this.setError(constant.INVALID_CODE);
      });
  };

  backToSignInHandler = () => {
    this.setState({
      isVerifyFormVisible: false,
      error: null,
      disableBtn: false,
    });
  };

  render() {
    // fetch classes (material UI styling) from props
    const { classes } = this.props;

    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div style={styles.innerCont}>
          <img style={styles.logo} src={Logo} alt="Service Activator" />
          {!this.state.isVerifyFormVisible ? (
            <div>
              <form className={classes.form} onSubmit={this.initiateAuth}>
                <TextField
                  error={!!this.state.error}
                  helperText={this.state.error}
                  fullWidth
                  type="tel"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  id="outlined-error-helper-text"
                  label={constant.MOBILE_NUMBER}
                  variant="outlined"
                  value={this.state.phone}
                  onChange={this.updatePhoneInput}
                  InputLabelProps={{
                    classes: { root: classes.cssLabel },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                />
                <Button
                  disabled={this.state.disableSignInBtn}
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  classes={{ disabled: classes.disabledButton }}
                  className={classes.submit}>
                  {constant.LOG_IN}
                </Button>
              </form>
            </div>
          ) : (
            <div>
              <form className={classes.form} onSubmit={this.verifyCodeHandler}>
                <TextField
                  autoComplete="off"
                  error={!!this.state.error}
                  helperText={this.state.error}
                  fullWidth
                  id="outlined-error-helper-text"
                  label={constant.VERIFICATION_CODE}
                  variant="outlined"
                  value={this.state.code}
                  onChange={this.updateCodeInput}
                  InputLabelProps={{
                    classes: { root: classes.cssLabel },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                />
                <Button
                  disabled={this.state.disableVerifyBtn}
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  classes={{ disabled: classes.disabledButton }}
                  className={classes.submit}>
                  {constant.VERIFY}
                </Button>
                <Button
                  onClick={this.backToSignInHandler}
                  color="primary"
                  className={classes.signInBtn}>
                  {constant.BACK_TO_SIGN_IN}
                </Button>
              </form>
              <p style={{ color: color.colorWhite }}>
                {constant.VERIFICATION_CODE_PAGE_DESC}
              </p>
            </div>
          )}
        </div>
        <p style={styles.copyrightTxt}>{constant.COPYRIGHT}</p>
      </Container>
    );
  }
}

// styling for material text inputs and buttons
const style = (theme) => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  disabledButton: {
    backgroundColor: `${color.colorMaterialDisabled} !important`,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    padding: "14px",
    color: color.colorWhite,
    backgroundColor: color.colorAccent,
    fontSize: "16px",
    "&:hover": {
      backgroundColor: color.colorAccentDark,
      "@media (hover: none)": {
        backgroundColor: color.colorAccent,
      },
    },
  },
  signInBtn: {
    color: color.colorAccent,
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: color.colorWhite,
  },
  cssLabel: {
    color: color.colorWhite,
  },
  cssFocused: {
    color: color.colorWhite,
  },
  cssOutlinedInput: {
    "&$cssFocused $notchedOutline": {
      borderColor: `${color.colorPrimary} !important`,
    },
    color: color.colorWhite,
  },
});

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: color.colorBlack,
    height: "100vh",
  },
  innerCont: {
    padding: "16px",
    textAlign: "center",
    marginTop: "24px",
  },
  input: {
    width: "100%",
    padding: "12px 20px",
    margin: "8px 0",
    display: "inline-block",
    border: "1px solid #ccc",
    borderRadius: "4px",
    boxSizing: "border-box",
    fontSize: "16px",
  },
  submit: {
    width: "100%",
    backgroundColor: color.colorAccent,
    color: color.colorWhite,
    padding: "14px 20px",
    margin: "8px 0",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
  },
  logo: {
    maxWidth: "300px",
    maxHeight: "250px",
  },
  copyrightTxt: {
    color: color.colorWhite,
    fontSize: "0.9rem",
    textAlign: "center",
  },
};

export default withStyles(style)(SignIn);
